const COUNTRY_PL_VALUE = '/api/countries/pl';

export default COUNTRY_PL_VALUE;
